import { useState, useEffect, useCallback } from 'react';
import { raf } from 'rafz';
function useElementSize(onSize) {
  let [state] = useState(() => ({
    elem: null,
    size: null,
    onSize,
    sensor: null
  }));
  useEffect(() => {
    if (onSize && !(state.elem || state.onSize)) {
      scheduleSizeUpdate(state);
    }
    state.onSize = onSize;
    updateSensor();
  });
  useEffect(() => () => {
    state.onSize = false;
  }, []);
  return useCallback(elem => {
    state.elem = elem;
    updateSensor();
  }, []);
  function updateSensor() {
    let {
      elem,
      sensor,
      onSize: onSize2
    } = state;
    if (!sensor != !(elem && onSize2)) {
      if (sensor) {
        if (loadQueue.delete(state)) {
          onSensorLoaded();
        }
        scheduleSizeUpdate(state);
        sensor.remove();
        sensor = null;
      } else {
        sensor = document.createElement("iframe");
        sensor.tabIndex = -1;
        sensor.style.cssText = "position:absolute;top:0;left:0;height:100%;width:100%;pointer-events:none;z-index:-1";
        loadCount++;
        loadQueue.add(state);
        sensor.onload = onSensorLoaded;
      }
      state.sensor = sensor;
      sensor && elem.appendChild(sensor);
    }
  }
}
let loadQueue = new Set();
let loadCount = 0;
function onSensorLoaded() {
  if (--loadCount == 0) {
    loadQueue.forEach(state => {
      scheduleSizeUpdate(state);
      state.sensor.contentWindow.onresize = () => scheduleSizeUpdate(state);
    });
    loadQueue.clear();
  }
}
let updateQueue = [];
function scheduleSizeUpdate(state) {
  let i = updateQueue.length;
  for (; i > 0; i--) {
    let queued = updateQueue[i - 1];
    if (queued == state) return;
    if (queued.elem && queued.elem.contains(state.elem)) {
      break;
    }
  }
  updateQueue.splice(i, 0, state);
  raf.onFrame(flushSizeUpdates);
}
function flushSizeUpdates() {
  let current = updateQueue;
  updateQueue = [];
  current.forEach(state => {
    let {
      elem,
      size,
      onSize
    } = state;
    if (onSize) onSize(state.size = elem ? {
      width: elem.clientWidth,
      height: elem.clientHeight
    } : null, size, elem);
  });
}
export { useElementSize };